<template>
  <div class="jzliu-bi-engine-data-chart-preview" v-if="dialogVisible">
    <template v-if="mode !== 'drawer'">
      <el-dialog top="5vh" width="90%" :visible.sync="dialogVisible" append-to-body :title="title">
        <chart-data-table :selectItem="chartData" :data="data" @sort-change="handleSortChange" />
      </el-dialog>
    </template>
    <template v-else>
      <el-drawer :modal="false" class="jzliu-bi-engine-dws-preview-drawer" :visible.sync="dialogVisible" :direction="direction" :title="title" append-to-body>
        <div slot="title">
          <span>{{ title }}</span>
          <el-tooltip content="仅展示最近1000条数据" placement="right">
            <i class="el-icon-info"></i>
          </el-tooltip>
        </div>
        <chart-data-table :selectItem="chartData" :data="data" @sort-change="handleSortChange" />
      </el-drawer>
    </template>
  </div>
</template>

<script>
import chartDataTable from './chartDataTable.vue'
export default {
  name: "dataChartPreview",
  components: { chartDataTable },
  props: {
    direction: {
      type: String,
      default: 'rtl'
    },
    mode: {
      type: String,
      default: 'drawer'
    },
    chartData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    title() {
      return this.chartData.dataSetName + '图表数据'
    },
    data() {
      return this.chartData.chartData || []
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleSortChange(column) {
      this.$emit('sort-change', column)
    }
  }
}
</script>

<style scoped lang="less">
.jzliu-bi-engine-dws-preview {
  width: 100%;
  height: 100%;
}

/deep/ .el-dialog__body {
  max-height: none;
}
</style>

<style lang="less" scoped>
.jzliu-bi-engine-dws-preview-drawer .el-drawer__open .el-drawer.btt{
  height: 80% !important;
}
/deep/ .el-table__empty-block{
  min-height: 500px !important;
}
</style>